export const influencers = [
  {
    id: 1,
    name: "Jessica M.",
    platform: "TikTok",
    handle: "@jessicafinds",
    followers: "2.4M",
    niche: "Fashion & Lifestyle",
    earnings: "$8,200/mo",
    avatar: "https://public.readdy.ai/ai/img_res/b4a8ab13a2f0e6960987a75e36542e68.jpg",
    icon: "ri-tiktok-line",
    color: "#010101",
  },
  {
    id: 2,
    name: "Marcus T.",
    platform: "YouTube",
    handle: "@marcustech",
    followers: "890K",
    niche: "Tech Reviews",
    earnings: "$5,600/mo",
    avatar: "https://readdy.ai/api/search-image?query=young%20man%20tech%20reviewer%20smiling%20with%20gadgets%2C%20bright%20studio%20background%2C%20casual%20smart%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20content%20creator%20look&width=200&height=200&seq=inf2&orientation=squarish",
    icon: "ri-youtube-line",
    color: "#FF0000",
  },
  {
    id: 3,
    name: "Sophia R.",
    platform: "Instagram",
    handle: "@sophiastyle",
    followers: "1.1M",
    niche: "Home Decor",
    earnings: "$4,300/mo",
    avatar: "https://readdy.ai/api/search-image?query=woman%20home%20decor%20influencer%20smiling%20warmly%2C%20bright%20studio%20background%2C%20elegant%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20lifestyle%20content%20creator&width=200&height=200&seq=inf3&orientation=squarish",
    icon: "ri-instagram-line",
    color: "#E1306C",
  },
  {
    id: 4,
    name: "Derek L.",
    platform: "YouTube",
    handle: "@derekdeals",
    followers: "560K",
    niche: "Deals & Savings",
    earnings: "$3,100/mo",
    avatar: "https://readdy.ai/api/search-image?query=young%20man%20deals%20blogger%20smiling%20confidently%2C%20bright%20studio%20background%2C%20casual%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20social%20media%20influencer%20look&width=200&height=200&seq=inf4&orientation=squarish",
    icon: "ri-youtube-line",
    color: "#FF0000",
  },
  {
    id: 5,
    name: "Mei Xiao",
    platform: "Douyin",
    handle: "@meixiao_life",
    followers: "5.8M",
    niche: "Lifestyle & Shopping",
    earnings: "$12,400/mo",
    avatar: "https://readdy.ai/api/search-image?query=young%20chinese%20woman%20lifestyle%20influencer%20smiling%20brightly%2C%20clean%20studio%20background%2C%20trendy%20outfit%2C%20professional%20portrait%20photo%2C%20white%20background%2C%20social%20media%20star%20look&width=200&height=200&seq=inf5&orientation=squarish",
    icon: "ri-tiktok-line",
    color: "#010101",
  },
  {
    id: 6,
    name: "Wei Zhang",
    platform: "WeChat",
    handle: "@weizhang_shop",
    followers: "3.2M",
    niche: "Food & Organic",
    earnings: "$7,800/mo",
    avatar: "https://readdy.ai/api/search-image?query=young%20chinese%20man%20food%20blogger%20smiling%20warmly%2C%20clean%20studio%20background%2C%20casual%20smart%20outfit%2C%20professional%20portrait%20photo%2C%20white%20background%2C%20content%20creator%20look&width=200&height=200&seq=inf6&orientation=squarish",
    icon: "ri-wechat-line",
    color: "#07C160",
  },
  {
    id: 7,
    name: "Lily Wang",
    platform: "Douyin",
    handle: "@lilywang_usa",
    followers: "4.1M",
    niche: "USA Factory Goods",
    earnings: "$9,600/mo",
    avatar: "https://readdy.ai/api/search-image?query=young%20asian%20woman%20fashion%20influencer%20smiling%20confidently%2C%20bright%20clean%20studio%20background%2C%20stylish%20outfit%2C%20professional%20portrait%20photo%2C%20white%20background%2C%20social%20media%20star&width=200&height=200&seq=inf7&orientation=squarish",
    icon: "ri-tiktok-line",
    color: "#010101",
  },
  {
    id: 8,
    name: "Carlos M.",
    platform: "Instagram",
    handle: "@carlosoutdoor",
    followers: "780K",
    niche: "Outdoor & Sports",
    earnings: "$4,900/mo",
    avatar: "https://readdy.ai/api/search-image?query=young%20hispanic%20man%20outdoor%20sports%20influencer%20smiling%2C%20bright%20studio%20background%2C%20athletic%20outfit%2C%20professional%20portrait%20photo%2C%20clean%20white%20background%2C%20content%20creator%20look&width=200&height=200&seq=inf8&orientation=squarish",
    icon: "ri-instagram-line",
    color: "#E1306C",
  },
];

export const resellerBenefits = [
  { icon: "ri-store-2-line", title: "No Inventory Needed", desc: "Sell products without holding stock. We ship directly to your customers from USA & Canada warehouses." },
  { icon: "ri-percent-line", title: "Factory-Set Commission", desc: "Each factory sets their own commission rate (5%–40%). You see the rate before promoting any product." },
  { icon: "ri-paypal-line", title: "PayPal Payouts", desc: "Receive your commissions directly to your PayPal account every month, automatically." },
  { icon: "ri-bar-chart-2-line", title: "Real-Time Sales Tracking", desc: "See exactly how many products you sold, clicks, and commission earned — updated live." },
];

export const platformList = ["All", "TikTok", "YouTube", "Instagram", "Douyin", "WeChat"];
